import { makeFetchData } from "api/makeApiRequestType/makeFetchData";
import { validate, ValidationCallback } from "validation/validate";
import { FollowUpChecksParams } from "validation/getFieldChecker";

type Params = {
	locationCountryCode: string;
};

export interface District {
	locationDistrict: string;
}

type Output = { districts: District[] };

const flagValidationErrorsInDistrict: ValidationCallback<District> = (
	input,
	{ flag, checkField }
) => {
	checkField("locationDistrict", { type: "string" });
};

const flagValidationErrors: ValidationCallback<Output> = (
	input,
	{ checkField },
	auth
) => {
	checkField("districts", {
		type: "array",
		followUpChecks: arg => {
			const { findInvalid, value } = arg as FollowUpChecksParams<"array">;

			value.forEach((district, districtOffset) => {
				const errorMessagePrefix = `District ${districtOffset}`;

				if (typeof district !== "object") {
					findInvalid(`${errorMessagePrefix}: not an object`);
					return;
				}

				validate(district, {
					doValidate: flagValidationErrorsInDistrict,
					withErrors: errors => {
						findInvalid(`Row ${districtOffset}: ${JSON.stringify(errors)}`);
					},
					auth
				});
			});
		}
	});
};

export const getLocationDistricts = makeFetchData<Params, Output>(
	"districts",
	flagValidationErrors,
	undefined,
	undefined,
	{ cacheInMemory: true }
);
